import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="bg-footer">
        <div className="copyright">
          <p>Copyright</p>
          <i className="far fa-copyright"></i>
          <p>Labo T.</p>
        </div>
        <div className="dev">
          <p>Developed by</p>
          <a
            href="https://lebolloch-dev.com/"
            target="_blank"
            title="Lebolloch-Dev"
            rel="noreferrer"
          >
            Lebolloch-Dev
          </a>
         
        </div>
        <p></p>
      </div>
    </footer>
  );
};

export default Footer;
